/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Apa_S5Inputs */

const en_tut_apa_s5 = /** @type {(inputs: Tut_Apa_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The **virtual office** is a map where the team is visibly present. You get an avatar and a desk, move between rooms, hear the people nearest you, and open a meeting from the room you are already in.`)
};

const id_tut_apa_s5 = /** @type {(inputs: Tut_Apa_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Kantor virtual** adalah peta tempat tim terlihat hadir. Anda punya avatar dan meja, bisa pindah ruang, mendengar rekan terdekat, dan membuka rapat dari ruang yang sama.`)
};

/**
* | output |
* | --- |
* | "The **virtual office** is a map where the team is visibly present. You get an avatar and a desk, move between rooms, hear the people nearest you, and open a ..." |
*
* @param {Tut_Apa_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_apa_s5 = /** @type {((inputs?: Tut_Apa_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Apa_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_apa_s5(inputs)
	return en_tut_apa_s5(inputs)
});